import { useRef, useState, useCallback } from "react";

const DISMISS_THRESHOLD = 80;

export function useSwipeToClose(onClose, { enabled = true } = {}) {
  const startY = useRef(null);
  const dragYRef = useRef(0);
  const [dragY, setDragY] = useState(0);

  const onTouchStart = useCallback((e) => {
    if (!enabled) return;
    startY.current = e.touches[0].clientY;
    dragYRef.current = 0;
  }, [enabled]);

  const onTouchMove = useCallback((e) => {
    if (!enabled || startY.current === null) return;
    const delta = e.touches[0].clientY - startY.current;
    if (delta > 0) {
      dragYRef.current = delta;
      setDragY(delta);
    }
  }, [enabled]);

  const onTouchEnd = useCallback(() => {
    if (!enabled) return;
    if (dragYRef.current > DISMISS_THRESHOLD) onClose();
    startY.current = null;
    dragYRef.current = 0;
    setDragY(0);
  }, [enabled, onClose]);

  return {
    handleProps: enabled ? { onTouchStart, onTouchMove, onTouchEnd } : {},
    dragStyle: (enabled && dragY > 0) ? { transform: `translateY(${dragY}px)`, transition: "none" } : {},
  };
}
